const additionalSounds = [
    {
        src: "sounds/End1.mp3",
        id: "endBugs",
    },
];
export default additionalSounds;
